module.exports = __webpack_public_path__ + "static/img/qrCodeCn.455984ba.png";